import * as Yup from 'yup';
import { OUTDOOR_GYM_EQUIPMENT_ID } from '../../../utils/enum';
// const koreanAndNumberPattern = /^[\uAC00-\uD7A3\d]*$/;
export const FACILITIES_SCHEMA = Yup.array()
  .min(1, '업로드된 시설물이 없습니다.')
  .max(300, '1회에 300건 까지만 등록 가능합니다.')
  .of(
    Yup.object().shape({
      addressName: Yup.string().required('주소는 필수 입력값입니다.'),
      addressNote: Yup.string()
        .max(100, '위치 참고는 최대 100자입니다.')
        .nullable(),
      categoryTitle: Yup.string().required('유형은 필수 입력값입니다.'),
      subCategoryId: Yup.string().when('categoryId', {
        is: value => value === OUTDOOR_GYM_EQUIPMENT_ID,
        then: schema => schema.required('운동기구명은 필수 입력값입니다.'),
        otherwise: schema => schema.nullable(),
      }),
      title: Yup.string()
        .max(100, '시설명은 최대 100자입니다.')
        .required('시설명은 필수 입력값입니다.'),
      serialNumber: Yup.string().required('필수 입력값입니다.'),
      // .matches(
      //   koreanAndNumberPattern,
      //   '-없이 해당동과 관리번호 숫자를 입력해주세요',
      // )
      // .test(
      //   'last-four-are-digits',
      //   '해당동을 제외한 관리번호는 숫자로만 입력이 가능합니다.',
      //   value => {
      //     const lastFourCharacters = value.slice(-4);
      //     return /^\d{4}$/.test(lastFourCharacters);
      //   },
      // )
      // .min(5, '- 제외 최소 5자리 이상으로 입력해주세요.')
      // .max(7, '- 제외 최대 7자리 이하로 입력해주세요.'),
      installCostNation: Yup.mixed()
        .transform((v: any) => (v === '' ? undefined : v))
        .nullable()
        .test({
          message: '숫자만 입력해주세요.',
          name: 'isNumberErrorWhenDefined',
          test(value: any) {
            if (value === undefined || value === null || value === '') {
              return true;
            }
            if (typeof +value !== 'number' && !isNaN(+value)) {
              return false;
            }
            return true;
          },
        }),
      installCostCity: Yup.mixed()
        .transform((v: any) => (v === '' ? undefined : v))
        .nullable()
        .test({
          message: '숫자만 입력해주세요.',
          name: 'isNumberErrorWhenDefined',
          test(value: any) {
            if (value === undefined || value === null || value === '') {
              return true;
            }
            if (typeof +value !== 'number' && !isNaN(+value)) {
              return false;
            }
            return true;
          },
        }),
      installCostDistrict: Yup.mixed()
        .transform((v: any) => (v === '' ? undefined : v))
        .nullable()
        .test({
          message: '숫자만 입력해주세요.',
          name: 'isNumberErrorWhenDefined',
          test(value: any) {
            if (value === undefined || value === null || value === '') {
              return true;
            }
            if (typeof +value !== 'number' && !isNaN(+value)) {
              return false;
            }
            return true;
          },
        }),
      occupyingSpace: Yup.mixed()
        .transform((v: any) => (v === '' ? undefined : v))
        .nullable()
        .test({
          message: '숫자만 입력해주세요.',
          name: 'isNumberErrorWhenDefined',
          test(value: any) {
            if (value === undefined || value === null || value === '') {
              return true;
            }
            if (typeof +value !== 'number' && !isNaN(+value)) {
              return false;
            }
            return true;
          },
        }),
      manageDepartment: Yup.string().nullable(),
      usedAs: Yup.string().max(100, '유형상세는 최대 100자입니다.').nullable(),
      installDepartment: Yup.string().nullable(),
      maintenanceDepartment: Yup.string().nullable(),
      contactNumber: Yup.mixed()
        .transform((v: any) => (v === '' ? undefined : v))
        .nullable()
        .test({
          message: '숫자만 입력해주세요.',
          name: 'isNumberErrorWhenDefined',
          test(value: any) {
            if (value === undefined || value === null || value === '') {
              return true;
            }
            if (typeof +value !== 'number' && !isNaN(+value)) {
              return false;
            }
            return true;
          },
        }),
      consignedOrg: Yup.string().nullable(),
      administrativeRegion: Yup.string()
        .max(100, '행정동은 최대 100자입니다.')
        .nullable(),
      actualRegion: Yup.string()
        .max(100, '해당동은 최대 100자입니다.')
        .nullable(),
      notes: Yup.string().max(1000, '비고는 최대 1000자입니다.').nullable(),
      inspectionScore: Yup.string().when('categoryId', {
        is: value => value === OUTDOOR_GYM_EQUIPMENT_ID,
        then: schema => schema.required('점검상태는 필수 입력값입니다.'),
        otherwise: schema => schema.nullable(),
      }),
      inspectionResult: Yup.array()
        .typeError('상태비고는 (,)로 구분해 주세요.')
        .nullable(),
      inspectionDate: Yup.string().when('categoryId', {
        is: value => value === OUTDOOR_GYM_EQUIPMENT_ID,
        then: schema => schema.required('점검일자는 필수 입력값입니다.'),
        otherwise: schema => schema.nullable(),
      }),
      inspectionNote: Yup.string()
        .max(1000, '점검내용은 최대 1000자입니다.')
        .nullable(),
    }),
  );
